/* eslint-disable */
import HandleResponses from '@common/utils/handleResponses';
import axios from '../../../axios';
import tmsOptimaAxiosInstance from '../../../tms-optima-axios';
import tmsMdmAxiosInstance from '../../../tms-mdm-axios';
import tmsErpAxiosInstance from '../../../tms-erp-axios';
import {defaultSettings} from '@/constants/optima';
import {isBoolean} from 'lodash';
import {formSortPayload} from "../../../helpers/common";

const actions = {
  async bulkUpload({ commit }, data) {
    try {
      commit('setLoading', true);
      commit('emptyIndent', []);
      commit('setNotCombineList', []);
      commit('setUploadDetails', {});
      const result = await tmsOptimaAxiosInstance.post(`/optima/bulkupload?movement=${data.movement}`, data.formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async bulkUploadV2({ commit }, data) {
    try {
      commit('setLoading', true);
      commit('emptyIndent', []);
      commit('setNotCombineList', []);
      commit('setUploadDetails', {});
      const result = await tmsOptimaAxiosInstance.post(`/optima/bulkuploadV2?movement=${data.movement}`, data.formData, { headers: {
          'Content-Type': 'multipart/form-data',
        } });
      return result.data;
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async consolidatedVendorBulkUpload({ commit }, data) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.post('/optima/consolidatedVendorBulkUpload', data.formData, { headers: {
          'Content-Type': 'multipart/form-data',
        } });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async downloadInvalid({ commit }, params) {
    try {
      const result = await tmsOptimaAxiosInstance({ url: '/optima/downloadVendorUploadInvalidMaterials',
        method: 'GET',
        responseType: 'blob',
        params,
      });
      return result;
    } catch (error) {
      return error;
    }
  },
  async uploadStatus({ commit }) {
    try {
      const result = await tmsOptimaAxiosInstance.get('/optima/upload_status');
      if (result.data.code !== 'PROGRESS') {
        commit('setLoading', false);
        commit('setUploadDetails', result.data);
      }
      return result.data;
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async uploadStatusV2({ commit }, { progressId }) {
    try {
      const result = await tmsOptimaAxiosInstance.get(`/optima/bulkuploadv2/get_status/${progressId}`);
      if (result.data.code !== 'PROGRESS' || result.data.code !== 'CREATED') {
        commit('setUploadDetails', result.data);
      }
      return result.data;
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async moveToPendingStatus({commit}) {
    try {
      const result = await tmsOptimaAxiosInstance.get('/optima/move_to_pending_status');
      if (result.data.code !== 'PROGRESS') {
        commit('setLoading', false);
        commit('setUploadDetails', result.data);
      }
      return result.data;
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async tsOptimize(_, params) {
    try {
      const result = await tmsOptimaAxiosInstance.get('/optima/toursolver/optimize', { params });
      return result;
    } catch (error) {
      return error;
    }
  },
  async getIframeToken(_, params) {
    try {
      const result = await tmsOptimaAxiosInstance.get('/optima/toursolver/token', { params });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async tsStatusCheck(_, params) {
    try {
      const result = await tmsOptimaAxiosInstance.get('/optima/toursolver/status', { params });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async tsBulkUpload({ commit }, { type, formData }) {
    try {
      const result = await tmsOptimaAxiosInstance.post(`/optima/toursolver/bulkupload?type=${type}`, formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async tsClearDetails() {
    try {
      const result = await tmsOptimaAxiosInstance.put(`/optima/toursolver/clear-details`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async vendorUploadStatus({ commit }) {
    try {
      const result = await tmsOptimaAxiosInstance.get('/optima/vendor_upload_status');
      return result.data;
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async invoke({ commit }, { fileName, consignees, deliveryHold, movement , depot_id} ) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.put('/optima/invoke', { processFile: fileName, movement, consignees, deliveryHold, depot_id });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async moveToPending({ commit }, { optima_materials_key, movement , depot_id}) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.put('/optima/upload/move-to-pending', { optima_materials_key, movement, depot_id });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async moveOrdersToPending({ commit }, { data, query = {} }) {
    try {
      const {
        delivery_number,
        delivery_type,
        consignee_ref_id,
        consignee_name,
        transporter_ref_id,
        transporter_name,
        material_code,
        destination_city,
        top_up,
        under_utilized_indent,
        material_category,
        vehicle_mode,
        truck_type,
        job_id,
        retained_only,
      } = query;
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.put('/optima/move-orders-to-pending', { data }, { params: {
          delivery_number,
          delivery_type,
          consignee_ref_id,
          consignee_name,
          transporter_ref_id,
          transporter_name,
          material_code,
          destination_city,
          top_up,
          under_utilized_indent,
          material_category,
          vehicle_mode,
          truck_type,
          job_id,
          retained_only,
        } });
      if(HandleResponses.Status(result).success){
        commit('setLoading',false)
      }
      return result.data;
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async invokeStatus({ commit }, {depot_id, movement}) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.get(`/optima/V2/invoke_status/?depot_id=${depot_id}&movement=${movement}`);
      if (result.data.code === 'COMPLETED') {
        setTimeout(() => {
          commit('setLoading', false);
        }, 8000);
      }
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },

  async deliveryStatus({ commit }) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.get('/optima/V2/delivery_run_status');
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },

  async inputConstructionStatus({ commit }, {depot_id, movement}) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.get(`/optima/input_construction_status?depot_id=${depot_id}&movement=${movement}`);
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async discardOrderStatus({ commit }, {transactionId}) {
    try {
      const result = await tmsOptimaAxiosInstance.get(`/optima/check-discard-status/${transactionId}`);
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },

  async conversionStatus({ commit }) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.get('/optima/check-indents');
      if (result.data.code !== 'PROGRESS') {
        commit('setLoading', false);
        if (result.data.rejectCount) {
          commit('setRejectedCount', result.data);
        }
      }
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },

  async creationStatus({ commit }) {
    try {
      commit('isIndentUpdating', true);
      const result = await tmsOptimaAxiosInstance.get('/optima/indent_status');
      if (result.data.code !== 'PROGRESS') {
        commit('isIndentUpdating', false);
      }
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      commit('isIndentUpdating', false);
      return HandleResponses.Status(error);
    }
  },

  async getIndentsCount({ commit }, { data, query = {} }) {
    try {
      const {
        delivery_number,
        delivery_type,
        consignee_ref_id,
        consignee_name,
        transporter_ref_id,
        transporter_name,
        material_code,
        destination_city,
        top_up,
        under_utilized_indent,
        non_under_utilized_indent,
        material_category,
        vehicle_mode,
        truck_type,
        job_id,
        retained_only,
      } = query;
      commit('isIndentUpdating', true);
      const result = await tmsOptimaAxiosInstance.post('/optima/get_selected_indents_count', { data }, { params: {
          delivery_number,
          delivery_type,
          consignee_ref_id,
          consignee_name,
          transporter_ref_id,
          transporter_name,
          material_code,
          destination_city,
          top_up,
          under_utilized_indent,
          non_under_utilized_indent,
          material_category,
          vehicle_mode,
          truck_type,
          job_id,
          retained_only,
        } });
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('isIndentUpdating', false);
    }
  },

  async vehicleList({ commit }) {
    try {
      const result = await tmsMdmAxiosInstance('/vehicle/optima-settings');
      if (result && result.data) {
        commit('setVehicles', result.data);
      }
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setLoading', false);
    }
  },

  async list({ commit }, data ) {
    try {
      const {
        page,
        depot_id,
        job_id,
        movement,
        delivery_number,
        delivery_type,
        pickup,
        shipTo,
        soldTo,
        transporter_ref_id,
        transporter_name,
        material_code,
        destination_city,
        top_up,
        under_utilized_indent,
        non_under_utilized_indent,
        material_category,
        vehicle_mode,
        truck_type,
        sort,
        date_filters,
        allowPartialIndenting,
        selectAll,
        selectedIndentMap,
        indentIdWiseData,
        retainedOnly = false,
      } = data
      commit('setLoading', true);
      if (page > 1) {
       commit('paginationCheck', true);
      }

      let sortParams = {};

      for (const [key, value] of Object.entries(sort)) {
        if (isBoolean(value)) {
          sortParams[`${key}_sort`] = formSortPayload(value);
        }
      }

      const result = await tmsOptimaAxiosInstance('/optima', { params: {
          page,
          depot_id,
          job_id,
          movement,
          delivery_number,
          delivery_type,
          transporter_ref_id,
          transporter_name,
          pickup,
          shipTo,
          soldTo,
          material_code,
          destination_city,
          top_up,
          under_utilized_indent,
          non_under_utilized_indent,
          material_category,
          vehicle_mode,
          truck_type,
          ...sortParams,
          date_filters,
          retained_only: retainedOnly,
        }  });

      const updatedIndentIdwiseData = { ...indentIdWiseData };
      if (result && result.data) {
        const gatesIds = result.data.reduce((acc, indent) => {
          indent.consignees.forEach((consignee) => {
            if (consignee.gate_id) {
              acc.push(consignee.gate_id);
            }
          });
          return acc;
        }, []);
        if (gatesIds && gatesIds.length) {
          const gateDataResponse = await tmsOptimaAxiosInstance.post('/optima/gates', { data: { gate_ids: gatesIds } });
          if (gateDataResponse && gateDataResponse.data) {
            commit('setGatesMap', gateDataResponse.data);
          }
        }
        const updatedSelectedIndentMap = { ...selectedIndentMap };
        result.data.forEach((indent) => {
          updatedIndentIdwiseData[indent.id] = indent;
          updatedSelectedIndentMap[indent.id] = false;
          if (selectAll) {
            updatedSelectedIndentMap[indent.id] = true;
          } else if (!allowPartialIndenting && indent.associated_ids.length) {
            updatedSelectedIndentMap[indent.id] =
              indent.associated_ids.some(associatedId =>
                updatedSelectedIndentMap[associatedId] === true);
          }
        });
        commit('setLoading', false);
        commit('selectedIndents', updatedSelectedIndentMap);
        commit('indentIdWiseData', updatedIndentIdwiseData);
        commit('setIndents', result.data);
        commit('setIndentCount', result.count);
        commit('setDeliveryProcessedCounts', result.delivery_counts);
        commit('setInvalidPath', result.invalid_data_path);
      }
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('setLoading', false);
    }
  },
  async indentsSummary({ commit }, { depot_id, movement, job_id }) {
    try {
      const result = await tmsOptimaAxiosInstance('/optima/indents-summary', { params: {  depot_id, movement, job_id }  });
      if (result && result.data) {
        commit('setSummary', result.data);
      }
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async search({ commit }, { query, page, depot_id }) {
    try {
      commit('isIndentUpdating', true);
      const result = await tmsOptimaAxiosInstance('optima/search/', {
       params: {
        query,
        page,
        depot_id
       }
      });
      if (result && result.data) {
        commit('OPTIMA_DATA', result.data.indents);
        if (result.data.totals.length) {
          commit('setSummary', result.data.totals[0]);
        } else {
          commit('setSummary', {});
        }
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('isIndentUpdating', false);
    }
  },


  async default_settings({ commit }, {depotId, movement}) {
    try {
      commit('setLoading', true);
      commit('setDefaultDepot', {depotId, movement});
      const result = await axios('/settings/depot/optima', { params: {depot_id: depotId, movement }});
      if (result && result.data.depot_id) {
        const getResult = Object.assign(result.data, { movement: movement});
        commit('setSetting', getResult);
      }else{
        const defaultOptimaConfig = (result && result.data && result.data.optima_configuration) ? result.data.optima_configuration : {};
        commit('setDefaultSetting', { ...defaultSettings, ...defaultOptimaConfig});
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setLoading', false);
    }
  },

  async autoRunSettings({ commit }, {depotId, movement}) {
    try {
      commit('setLoading', true);
      commit('setDefaultDepot', {depotId, movement});
      const result = await axios('/settings/depot/optima_auto_run', { params: {depot_id: depotId, movement } });
      if (result && result.data) {
        commit('setOptimaAutoRun', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setLoading', false);
    }
  },

  async autoIndentSettings({ commit }, {depotId, movement}) {
    try {
      commit('setLoading', true);
      commit('setDefaultDepot', {depotId, movement});
      const result = await axios('/settings/depot/optima_auto_indent', { params: {depot_id: depotId, movement } });
      if (result && result.data) {
        commit('setOptimaAutoIndent', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setLoading', false);
    }
  },

  async updateAutoIndentSettings({ commit }, { data }) {
    try {
      commit('setLoading', true);
      let url = `/settings/depot/optima_auto_indent`;
      return await axios.put(url, { data });
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setLoading', false);
    }
  },

  async holdConsigneeSubmit({ commit }, data) {
    try {
      const result = await tmsOptimaAxiosInstance.put('/optima/hold-deliveries', {data: data} );
      commit('setHoldConisgnee', data);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async setting_update({ commit }, { data, depot }) {
    try {
      const passdata = {};
      passdata.optima_configuration = {...data};
      passdata.depot_ids = [depot.depot_id];
      passdata.movement = depot.movement;

      const result = await axios.put('/settings/depot/optima', passdata );
      if (result && result.data) {
        const getResult = Object.assign(result.data, { movement: passdata.movement });
        commit('setSetting', getResult);
      } else {
        commit('makeEmptySetting', { ...defaultSettings});
      }

      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async consignees({ commit }, indentId) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.get(`/optima/${indentId}/consignees`);
      if (result && result.data) {
        commit('setIndent', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('setLoading', false);
    }
  },

  async currentJobConsignees({ commit }, jobId ) {
    try {
      const result = await tmsOptimaAxiosInstance.get(`/optima/current_job_consignees/${jobId}`);
      if (result && result.data) {
        return result.data;
      }
    } catch (err) {
      return err;
    }
  },

  async materials({ commit }, { indentId, consigneeId }) {
    try {
      const result = await tmsOptimaAxiosInstance.get(`/optima/${indentId}/materials/${consigneeId}`);
      if (result && result.data) {
        commit('setMaterials', result.data);
        commit('setOrderDetails', result.order);
      }
      return result;
    } catch (err) {
      return err;
    }
  },

  async deleteMaterials({}, params) { // eslint-disable-line
    try {
      const result = await tmsOptimaAxiosInstance.delete(`/optima/${params.indentId}/materials`, {
        data: { data: params.materials },
      });
      return HandleResponses.Status(result);
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async deleteIndents({ commit }, { data, query = {} }) {
    try {
      const {
        delivery_number,
        delivery_type,
        consignee_ref_id,
        consignee_name,
        transporter_ref_id,
        transporter_name,
        material_code,
        destination_city,
        top_up,
        under_utilized_indent,
        material_category,
        vehicle_mode,
        truck_type,
        job_id,
        retained_only,
      } = query;
      const result = await tmsOptimaAxiosInstance.put('/optima', { data }, { params: {
          delivery_number,
          delivery_type,
          consignee_ref_id,
          consignee_name,
          transporter_ref_id,
          transporter_name,
          material_code,
          destination_city,
          top_up,
          under_utilized_indent,
          material_category,
          vehicle_mode,
          truck_type,
          job_id,
          retained_only,
        } });
      return result.data;
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async deleteConsignee({ commit }, { indent_id, consignee_id }) {
    try {
      commit('isIndentUpdating', true);
      const result = await tmsOptimaAxiosInstance.delete(`/optima/${indent_id}/consignee`, { data: { data: { consignee_id } } });
      return HandleResponses.Status(result);
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('isIndentUpdating', false);
    }
  },

  async indents({ commit }, { data, query = {} }) {
    try {
      const {
        delivery_number,
        delivery_type,
        consignee_ref_id,
        consignee_name,
        transporter_ref_id,
        transporter_name,
        material_code,
        destination_city,
        top_up,
        under_utilized_indent,
        non_under_utilized_indent,
        material_category,
        vehicle_mode,
        truck_type,
        job_id,
        retained_only,
      } = query;
      commit('isIndentUpdating', true);
      const result = await tmsOptimaAxiosInstance.post('/optima', { data }, { params: {
          delivery_number,
          delivery_type,
          consignee_ref_id,
          consignee_name,
          transporter_ref_id,
          transporter_name,
          material_code,
          destination_city,
          top_up,
          under_utilized_indent,
          non_under_utilized_indent,
          material_category,
          vehicle_mode,
          truck_type,
          job_id,
          retained_only,
        } });
      commit('deleteIndents', data.ids);
      return HandleResponses.Status(result);
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('isIndentUpdating', false);
    }
  },

  async indent_split(_, { data }) {
    try {
      const result = await tmsOptimaAxiosInstance.post('/optima/indent_split', { data });
      return HandleResponses.Status(result);
    } catch(err) {
      return HandleResponses.Status(err);
    }
  },
  async indent_combine(_, { data }) {
    try {
      const result = await tmsOptimaAxiosInstance.post('/optima/indent_combine', { data });
      return result.data;
    } catch(err) {
      return HandleResponses.Status(err);;
    }
  },

  async retain_orders(_, { data }) {
    try {
      const result = await tmsOptimaAxiosInstance.post('/optima/retain_orders', { data });
      return result.data;
    } catch(err) {
      return HandleResponses.Status(err);;
    }
  },

  async revert_retained_orders(_, { data }) {
    try {
      const result = await tmsOptimaAxiosInstance.post('/optima/revert_retained_orders', { data });
      return result.data;
    } catch(err) {
      return HandleResponses.Status(err);;
    }
  },

  async combine_status() {
    try {
      const result = await tmsOptimaAxiosInstance.get(`/optima/combine_status`);
      return result.data;
    } catch (err) {
      return err;
    }
  },

  async download({ commit }, { ids, depot_id, movement, job_id }) {
    commit('isIndentUpdating', true);
    try {

      const result = await tmsOptimaAxiosInstance({ url: '/optima/download',
        method: 'POST',
        responseType: 'blob',
        data: {ids , depot_id, movement, job_id} });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        let optimaRunName = localStorage.getItem('last_optima_run_name');
        if((optimaRunName && optimaRunName !== 'undefined')) {
          optimaRunName = `${optimaRunName}-`;
        }else{
          optimaRunName = '';
        }

        link.setAttribute('download', `${optimaRunName}optimaReport-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('isIndentUpdating', false);
    }
  },

  async downloadDeliveriesWithConsignee({ commit }) {
    try {
      const result = await tmsOptimaAxiosInstance({ url: '/optima/upload/get_material_with_consignee_excel_template',
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `deliveryPicklistWithConsignee-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (err) {
      return err;
    }
  },

  async deliveryPicklistWithConsignee({ commit }, data) {
    try {
      commit('setLoading', true);
      commit('emptyIndent', []);
      commit('setNotCombineList', []);
      commit('setUploadDetails', {});
      const result = await tmsOptimaAxiosInstance.post(`/optima/upload/material_with_consignee?movement=${data.movement}`, data.formData, { headers: {
          'Content-Type': 'multipart/form-data',
        } });
      return result.data;
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },

  async downloadSampleExcel({ commit }) {
    try {
      const result = await tmsOptimaAxiosInstance({ url: '/optima/bulkuploadv2/get_optima_excel_template',
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `optimaUploadTemplate-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (err) {
      return err;
    }
  },
  async varianceDownload(_, params) {

    const { depot_id, date } = params;
    try {

      const result = await tmsOptimaAxiosInstance({ url: '/optima/varianceDownload',
        method: 'GET',
        responseType: 'blob',
        params: { depot_id, date} });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `optimaVarianceReport-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return result;
    } catch (err) {
      return err;
    }
  },

  async moveConsignee({ commit }, { data }) {
    try {
      commit('isIndentUpdating', true);
      const result = await tmsOptimaAxiosInstance.put('/optima/move-consignee', { data });
      return HandleResponses.Status(result);
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('isIndentUpdating', false);
    }
  },

  async orders({ commit }, data) {
    try {
      commit('isIndentUpdating', true);
      const result = await tmsOptimaAxiosInstance.post('/optima/indents-compare', { data });
      if (result && result.data) {
        commit('setIndentIds', data);
        commit('editIndents', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('isIndentUpdating', false);
    }
  },

  async update({ commit }, { data }) {
    try {
      commit('isIndentUpdating', true);
      const result = await tmsOptimaAxiosInstance.put('/optima', { data });
      return HandleResponses.Status(result);
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('isIndentUpdating', false);
    }
  },

  async show({ commit }, { Id, isEditPage= false, sourceSwapMapper = {}, destinationSwapMapper = {}, page = '' }) {
    try {
      commit('isIndentUpdating', true);
      const result = await tmsOptimaAxiosInstance(`/optima/${Id}?isEditPage=${isEditPage}&sourceSwapMapper=${JSON.stringify(sourceSwapMapper)}&destinationSwapMapper=${JSON.stringify(destinationSwapMapper)}&page=${page}`,);
      if (result && result.data) {
        commit('updateIndent', result.data);
      }
      return result.data;
    } catch (err) {
      console.log("Error: ", err);
      return err;
    } finally {
      commit('isIndentUpdating', false);
    }
  },
  async getVehicleNumberList(_, { data }) {
    try {
      const result = await tmsOptimaAxiosInstance.get('optima/search_vehicles', { params: data });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getindents({ commit }, { Ids, depotId, movement, page }) {
    try {
      commit('isIndentUpdating', true);
      const result = await tmsOptimaAxiosInstance(`/optima/indents/?ids=${Ids}&depotId=${depotId}&movement=${movement}&page=${page}`);
      if (result && result.data) {
        commit('updateIndent', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('isIndentUpdating', false);
    }
  },

  async getDeliveryPicks({commit}, { depotId, movement, params} ){
    try {
      commit('setLoading', true);
      const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
      const result = await tmsOptimaAxiosInstance(`/optima/delivery_picklist/${depotId}?customer_type=${movement}&${queryString}`);
      if (result && result.data) {
        commit('depotWiseDeliveryNos', result.data);
        commit('setDeliveryPicklistMeta', result.meta);
      }
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setLoading', false);
    }
  },

  async depotDeliveryOptimize({ commit }, data) {
    try {
      // commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.post('/optima/delivery_picklist_optimisation', { data });
      return HandleResponses.Status(result);
    } catch (err) {
      commit('setLoading', false);
      return HandleResponses.Status(err);
    } finally {
      // commit('setLoading', false);
    }
  },

  async depotIndentCount({ commit }, data) {
    try {
      const result = await tmsOptimaAxiosInstance.get(`/optima/indent-count?depot_id=${data.depot_id}&movement=${data.movement}`);
      return (result && result.data && result.data.indentCount) || 0;
    } catch (err) {
      commit('setLoading', false);
      return HandleResponses.Status(err);
    }
  },

  async depotMeta({ commit }, {depotId, movement, dateFilters, jobId, retainedOnly = false}) {
    try {
      let reqString = `/optima/depot_meta/${depotId}/${movement}?retainedOnly=${retainedOnly}`;
      if (dateFilters) {
        reqString += `&dateFilters=${dateFilters}`;
      }
      if (jobId) {
        reqString += `&jobId=${jobId}`;
      }
      const result = await tmsOptimaAxiosInstance.get(reqString);
      commit('setOptimaCurrentJobId', result.data.job_id || null);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async rejected(_, data) {
    try {
      const result = await tmsOptimaAxiosInstance.get(`/optima/rejected_deliveries/${data.reference_id}`);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
    }
  },

  async processed(_, data) {
    try {
      const result = await tmsOptimaAxiosInstance.get(`/optima/process_deliveries/${data.reference_id}`);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
    }
  },

  async getNotCombine({ commit }, { Id, movement }) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance(`/optima/meta/${Id}/${movement}`);
      if (result && result.data && result.data.consignees) {
        commit('setNotCombineList', result.data.consignees);
      }
      return result.data;
    } catch (err) {
      commit('setLoading', false);
      return HandleResponses.Status(err);
    } finally {
      commit('setLoading', false);
    }
  },
  saveNotCombine({commit}, { data } ) {
    commit('setNotCombineList', data);
    return true;
  },
  async pullDeliveryPicklist({ commit }, { data }) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance(`/optima/request_picklist/${data.depotId}/${data.movement}`);
      return result.data;
    } catch (err) {
      commit('setLoading', false);
      return HandleResponses.Status(err);
    } finally {
      commit('setLoading', false);
    }
  },
  async saveAutoRun({ commit }, { data, depot }) {
    try {
      const passdata = {...data};
      passdata.depot_ids = [depot.depot_id];
      passdata.movement = depot.movement;

      const result = await axios.put('settings/depot/optima_auto_run', passdata );
      if (result && result.data) {
        const getResult = Object.assign(result.data, {movement: passdata.movement});
        commit('setSetting', getResult);
      }else{
        commit('makeEmptySetting', '');
      }
      return result;
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    } finally {
      commit('setLoading', false);
    }
  },
  async downloadOptimaRejections(_, {depot_id, movement, stage, is_all_depot = false}) {
    try {
      const result = await tmsOptimaAxiosInstance({ url: '/optima/rejections-download',
        method: 'GET',
        responseType: 'blob',
        params: { depot_id, movement, stage, is_all_depot } });
      return result;
    } catch (err) {
      return err;
    }
  },
  async dicardOptimaRejections({ commit }, {depot_id, movement}) {
    try {
      const result = await tmsOptimaAxiosInstance({ url: '/optima/rejections',
        method: 'DELETE',
        params: { depot_id, movement } });
      if (result && result.data) {
        commit('setEmptyRejectionListData', result.data);
      }
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('paginationCheck', false);
    }
  },
  async OptimaRejectionsList({ commit }, {depot_id, movement, page, stage}) {
    try {
      if (page > 1) {
        commit('paginationCheck', true);
      }
      const result = await tmsOptimaAxiosInstance({ url: '/optima/rejections',
          method: 'GET',
          params: { depot_id, movement, page, stage } });
      if (result && result.data) {
        commit('setRejectionListData', result.data);
      }
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('paginationCheck', false);
    }
  },
  async moveToPendingDeliveries({ commit }, {data}) {
    try {
      const result = await tmsOptimaAxiosInstance.put('/optima/move-to-pending', {data} );
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async throughPutBreach(_, data) {
    try {
      let url = `/optima/throughput/?depot_id=${data.depot_id}&movement=${data.movement}&type=${data.type}`
      if (data.select_all) {
        url += `&select_all=${data.select_all}`;
      }
      if (data.order_ids) {
        url += `&order_ids=${data.order_ids}`;
      }
      const result = await tmsOptimaAxiosInstance(url);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async optimaOutputQueueStatus({ commit }, { optimaJob }) {
    try {
      const { jobId, childJobIds } = optimaJob;
      commit('setLoading', true);
      let result;
      if (childJobIds && childJobIds.length) {
        result = await tmsOptimaAxiosInstance.get(`/optima/optima_output_queue_status/track?jobId=${jobId}&childJobIds=${childJobIds.join(',')}`);
      } else {
        result = await tmsOptimaAxiosInstance.get(`/optima/optima_output_queue_status/track?jobId=${jobId}`);
      }
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },

  async verifyOptimaOutput({ commit }, { depotId, movement, jobId = null }) {
    try {
      commit('setLoading', true);
      let result;
      if (jobId) {
        result = await tmsOptimaAxiosInstance.get(`/optima/verify_optima_output/${depotId}/${movement}?jobId=${jobId}`);
      } else {
        result = await tmsOptimaAxiosInstance.get(`/optima/verify_optima_output/${depotId}/${movement}`);
      }
      commit('setOptimaCurrentJobId', result.data.jobId || null);
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },

  async getDayWiseJobs({ commit }, { depotId, movement }) {
    try {
      commit('setLoading', true);
      let result = result = await tmsOptimaAxiosInstance.get(`/optima/get_day_wise_jobs/${depotId}/${movement}`);
      return (result.data) ? result.data : HandleResponses.Status(result);
    } catch (error) {
      commit('setLoading', false);
      return HandleResponses.Status(error);
    }
  },

  async updateOrder({commit}, {indentId, data}) {
    try {
      const result = await tmsOptimaAxiosInstance.put(`/optima/update_indent/${indentId}`, { data });
      return HandleResponses.Status(result);
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async loadMaterialCategories(_, { depotId, movement }) {
    try {
      return tmsOptimaAxiosInstance
        .get(`/material_category?depot_id=${depotId}&movement=${movement}`);
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async loadMaterialPriorities(_, { depotId, movement }) {
    try {
      return tmsOptimaAxiosInstance
        .get(`/material_priority?depot_id=${depotId}&movement=${movement}`);
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async loadOrderTypeRules(_, { depotId, movement }) {
    try {
      return tmsOptimaAxiosInstance
        .get(`/optima/order_type_rules?depot_id=${depotId}&movement=${movement}`);
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async loadFieldPriorities(_, { depotId, movement }) {
    try {
      return tmsOptimaAxiosInstance
        .get(`/optima/field_priorities?depot_id=${depotId}&movement=${movement}`);
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getOrderTypes() {
    try {
      return tmsOptimaAxiosInstance
        .get('/optima/order_types');
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async updateOrderTypeRules(_, { depotId, movement, data }) {
    try {
      return tmsOptimaAxiosInstance
        .post(`/optima/update_order_type_rules?depot_id=${depotId}&movement=${movement}`, { data });
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async updateFieldPriorities(_, { depotId, movement, data }) {
    try {
      return tmsOptimaAxiosInstance
        .post(`/optima/update_field_priorities?depot_id=${depotId}&movement=${movement}`, { data });
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async updatedMaterialCategories(_, { depotId, movement, data }) {
    try {
      return tmsOptimaAxiosInstance
        .post(`/material_category?depot_id=${depotId}&movement=${movement}`, { data });
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async updatedMaterialPriority(_, { depotId, movement, data }) {
    try {
      return tmsOptimaAxiosInstance
        .post(`/material_priority?depot_id=${depotId}&movement=${movement}`, { data });
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async exportMaterialCategory({ commit }, { depotId, movement }) {
    commit('setDownloadStatus', true);
    try {
      const result = await tmsOptimaAxiosInstance({
        url: `/material_category/export?depot_id=${depotId}&movement=${movement}`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result.size) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `material-category-export-${now}.xlsx`);
        document.body.appendChild(link);
        link.click();
        return true;
      }
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setDownloadStatus', false);
    }
  },
  async uploadMaterialCategories(_, formData) {
    try {
      return await tmsOptimaAxiosInstance.post(`material_category/upload/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async materialCategoryUploadStatus({ commit }) {
    try {
      const result = await tmsOptimaAxiosInstance('/material_category/upload_status');
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async rejectDownload({ commit }, transactionIds) {
    try {
      const result = await tmsOptimaAxiosInstance({
        url: `/material_category/rejection?transaction_ids=${transactionIds.join(',')}`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `material-category-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    }
  },
  async picklistMeta({ commit }, params) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance('/optima-materials/picklist-meta', { params });
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setLoading', false);
    }
  },

  async picklistData({ commit }, params) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance('/optima-materials/consignee-wise-list', { params });
      commit('setDeliveryPicklist', result.data);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setLoading', false);
    }
  },

  async consigneePicklist({ commit }, params) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance('/optima-materials/get-consignee-picklist', { params });
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setLoading', false);
    }
  },

  async changeConsigneesStatus({ commit }, data) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.put('/optima-materials/change-consignees-status', { data });
      return HandleResponses.Status(result);
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async optimizationRequest({ commit }, data) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.post('/optima-materials/optimization-request', { data });
      return HandleResponses.Status(result);
    } catch (err) {
      commit('setLoading', false);
      return HandleResponses.Status(err);
    } finally {
      commit('setLoading', false);
    }
  },

  async addSplitQuantity({ commit }, data) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.put('/optima-materials/split-picklist', {data});
      return HandleResponses.Status(result);
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setLoading', false);
    }
  },

  async createIndent({ commit }, params) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance('/optima/getSourceDropoffs', { params });
      return result;
          } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setLoading', false);
    }
  },


  async materialBulkExport({ commit }, data) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance({
        url: '/optima-materials/bulk_export',
        method: 'post',
        responseType: 'blob',
        data: {
          ...data
        }
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `exportMaterial.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return HandleResponses.Status(result);
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setLoading', false);
    }
  },

  async topupMaterial({ commit }, data) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.put('/returnIndents', {data});
      commit('setDeliveryIndentsPickList', result.indentList);
      commit('setShowIndentTopupDrawer', true)
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setLoading', false);
    }
  },

  async indentTopup({ commit }, data) {
    try {
      commit('setLoading', true);
      const result = await tmsOptimaAxiosInstance.put('/submitTopup', {data});
      commit('setShowIndentTopupDrawer', false)
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async checkIndentTopupStatus({ commit }, {transactionId}) {
    try {
      const result = await tmsOptimaAxiosInstance.get(`/optima/check-indent-topup-status?transactionId=${transactionId}`);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async erpTrigger({ commit }, data) {
    try {
      commit('setLoading', true);
      const result = await tmsErpAxiosInstance.post(`/delivery_picklist/`, data);
      return result;
    } catch (error) {
      return HandleResponses.Status(error)
    }
  },

  async loadMaterialCategoryVehicleType(_, { depotId, movement }) {
    try {
      return tmsOptimaAxiosInstance.get(`/material_category_vehicle_types?depot_id=${depotId}&movement=${movement}`);
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async exportMaterialCategoryVehicleType({ commit }, { depotId, movement }) {
    commit('setDownloadStatus', true);
    try {
      const result = await tmsOptimaAxiosInstance({
        url: `/material_category_vehicle_types/export?depot_id=${depotId}&movement=${movement}`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result.size) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `material-category-type-export-${now}.xlsx`);
        document.body.appendChild(link);
        link.click();
        return true;
      }
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setDownloadStatus', false);
    }
  },

  async materialCategoryVehicleTypeBulkUpload(_, formData) {
    try {
      return await tmsOptimaAxiosInstance.post(`/material_category_vehicle_types/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      })
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async materialCategoryVehicleTypeUploadStatus({ commit }) {
    try {
      const result = await tmsOptimaAxiosInstance.get('/material_category_vehicle_types/upload_status');
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async materialCategoryVehicleTypeRejectionDownload({commit}, transactionIds) {
    try {
      const result = await tmsOptimaAxiosInstance({
        url: `/material_category_vehicle_types/rejection?transaction_ids=${transactionIds.join(',')}`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `material-category-vehicle-types-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async createMaterialCategoryVehicleType(_, { depotId, movement, data }) {
    try {
      return tmsOptimaAxiosInstance.post(`/material_category_vehicle_types?depot_id=${depotId}&movement=${movement}`, { data });
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async fmsVehicleEtaFetch({ commit }, data) {
    try {
      const result = await tmsMdmAxiosInstance.get(`/fms_vehicle_eta_fetch?depot_id=${data.depot_id}&movement=${data.movement}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error)
    }
  },

  async checkFetchVehicleEtaFetchStatus({ commit }, data) {
    try {
      const result = await tmsMdmAxiosInstance.get(`/fms_vehicle_eta_fetch_status?depot_id=${data.depot_id}&movement=${data.movement}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error)
    }
  },

  async getOptimaCustomFields() {
    try {
      const result = await tmsOptimaAxiosInstance.get(`/optima-materials/get_optima_customfields`);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getReturnContract(_, data) {
    try {
      const result = await tmsOptimaAxiosInstance.put(`optima/returnRoutes`, { data });
      return result && result.data;
    } catch (error) {
      return error;
    }
  },
};

export default actions;
